<template>
    <div class="float-left mr-1">
        <span class="text-primary">
            <i
                class="fa fa-edit fa-lg icon-button"
                title="Atualizar Dotação Orçamentária"
                @click.stop="abrirModal()"
            ></i>
        </span>
        <inserir-atualizar-dotacao-form
            acao="ATUALIZAR"
            :mostrarModal="mostrarModal"
            @modalFechado="mostrarModal = false"
            :valorTotal="valorTotal"
            :valorDisponivel="valorDisponivel"
            :rateio="rateio"
            @atualizarRateio="$emit('atualizarRateio', $event)"
            @obterUnidades="$emit('obterUnidades')"
            @obterProjetos="$emit('obterProjetos', $event)"
            @obterAcoes="$emit('obterAcoes', $event)"
            :unidades="unidades"
            :projetos="projetos"
            :acoes="acoes"
        ></inserir-atualizar-dotacao-form>
    </div>
</template>

<script>
import InserirAtualizarDotacaoForm from './InserirAtualizarDotacaoForm'

export default {
    components: {
        InserirAtualizarDotacaoForm
    },

    props: {
        rateio: {
            type: Object,
            default: () => {}
        },

        valorTotal: {
            type: Number,
            default: () => 0
        },

        valorDisponivel: {
            type: Number,
            default: () => 0
        },

        unidades: {
            type: Array
        }, 

        projetos: {
            type: Array
        }, 
        
        acoes: {
            type: Array
        }
    },

    data() {
        return {
            mostrarModal: false
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        }
    },

    created() {},

    computed: {},

    watch: {},

    validations: {}
}
</script>
